import $ from 'jquery';

function resetBtn(btn, errorMsg = 'Please select a product(s) before continuing.') {
	alert(errorMsg);
	btn.removeAttr('disabled');
}

function setupProductPageButton() {
	const btn = $('#reviewOrderBtn');

	if (btn.length) {
		const $form = btn.parent();
		$form.submit(function (e) {
			e.preventDefault();
			btn.attr('disabled', true);

			let selectedProducts = $('.prod_card.-is-selected');

			if (selectedProducts.length >= 1) {

				selectedProducts.each(function (index) {
					const $this = $(this);
					const id = $this.attr('data-purchaseid');
					const hidden = $form.find(`[data-purchaseable="${id}"]`)

					if (hidden.length) {
						hidden.remove();
					} else {
						$form.prepend(`<input type="hidden" name="purchasables[${index}][id]" value="${id}">`);
						$form.prepend(`<input type="hidden" name="purchasables[${index}][qty]" value="1">`);
					}
				});

				$form.off();
				$form.submit();

			} else {
				// if no products are selected in the extras page then move em along the checkout process
				if (window.location.href.indexOf('checkout/extras') === -1) {
					resetBtn(btn);
				} else {
					window.location.href = href;
				}
			}
		});
	}
}

function setupExtrasPageButton() {
	const extrasBtn = $('#extrasReviewOrderBtn');

	if (extrasBtn.length) {
		const $form = extrasBtn.parent();
		$form.submit(function (e) {
			e.preventDefault();
			extrasBtn.attr('disabled', true);

			let selectedProducts = $('.prod_card.-is-selected');
			let index = 0;
			if (selectedProducts.length >= 1) {
				//	add to cart here
				selectedProducts.each(function () {
					let _this = $(this);
					let qtyEl = _this.find('.product_qty > input'),
						qty = parseInt(qtyEl.val()),
						id = parseInt(_this.attr('data-purchaseid')),
						added = false;

					window.cartItems.forEach((el)=>{
						const data = JSON.parse(el);
						const pId = (data.productId),
							pQty = parseInt(data.qty);

						if (pId === id) {
							if (pQty !== qty) {
								$form.prepend(`<input type="hidden" name="lineItems[${data.lineItemId}][qty]" value="${pQty}">`)
							}

							added = true;
						}
					});

					if (!added) {
						$form.prepend(`<input type="hidden" name="purchasables[${index}][id]" value="${id}">`);
						$form.prepend(`<input type="hidden" name="purchasables[${index}][qty]" value="${qty}">`);
						index++;
					}
				});

			} else {

				// if (window.location.href.indexOf('checkout/extras') === -1) {
				// 	resetBtn(extrasBtn);
				// } else {
				// 	window.location.href = href;
				// }
			}

			window.cartItems.forEach((el)=>{
				const data = JSON.parse(el);
				const pId = parseInt(data.productId);
				const pEl = $(`.prod_card[data-purchaseid="${pId}"]`);

				if (pEl.length) {
					const pElQty = pEl.find('.product_qty > input').val();

					// const removedEl = $(`[data-removed=${pId}]`);
					if (parseInt(pElQty) === 0) {
						$form.prepend(`<input type="hidden" name="lineItems[${data.lineItemId}][remove]" value="✓" data-removed="${pId}">`)
					}
				}
			});

			$form.off();
			$form.submit();
		});
	}
}

function setupOrderNowPageButton() {
	const placeOrder = $('.order-now');

	if (placeOrder.length) {
		const $form = $('#paymentForm');
		const cartDetailForm = $('#cartDetailForm');
		cartDetailForm.submit(function(e) {
			e.preventDefault();
		});

		placeOrder.click(function (e) {
			e.preventDefault();
			const masterCheck = $('#master-agreement');
			placeOrder.attr('disabled', true);

			if (!masterCheck.is(":checked")) {
				$('#master-agreement').parent().parent().find("label").addClass('+color-error');
				resetBtn(placeOrder, 'Please tick that you have read the CommsChoice Master Service Agreement');
				return;
			}

			masterCheck.parent().parent().find("label").removeClass('+color-error');
			if (!masterCheck.is(":checked")) {
				masterCheck.parent().parent().find("label").addClass('+color-error');
				resetBtn(placeOrder, 'Please make sure medical alarm not connected to');
				return;
			}

			masterCheck.parent().parent().find("label").removeClass('+color-error');

			// assign firname last name into addresses
			let firstName = $('input[name="fields[firstName]"]').val()
			let lastName = $('input[name="fields[lastName]"]').val()

			$('input[name="billingAddress[firstName]"]').val(firstName)
			$('input[name="shippingAddress[firstName]"]').val(firstName)

			$('input[name="billingAddress[lastName]"]').val(lastName)
			$('input[name="shippingAddress[lastName]"]').val(lastName)

			cartDetailForm.removeClass('-checked');

			// console.log('valid: ', cartDetailForm[0].checkValidity());

			if (!cartDetailForm[0].checkValidity()) {
				let invalids = cartDetailForm.find(':invalid');
				let firstInvalid = invalids.first();
				invalids.find(':invalid').each(function (e) {
					let field = $(this);
					field.closest('.float-label').addClass('is-invalid');
					field.on('focusin', function () {
						field.closest('.float-label').removeClass('is-invalid');
					});
				});

				cartDetailForm.addClass('-checked');
				resetBtn(placeOrder, 'There\'s an issue with the data your entered. Please review and try again.');
				$('html, body').animate({
					scrollTop: firstInvalid.offset().top - 100
				}, 1000, function () {
					firstInvalid.focus();
				});
			} else {
				$.ajax({
					url: '',
					type: 'post',
					data: cartDetailForm.serializeArray(),
					dataType: 'json',
					success: function(response) {
						if (response.success) {
							$form.submit();
						} else {
							alert('Something went wrong when ordering. Please try again later or email us about it.')
						}
					}
				});
				// $.getJSON('', cartDetailForm.serializeArray()).done(function (data) {
				// 	console.log(data);
				// 	// $form.submit();
				// });
			}
		});
	}
}

export default function productSubmitDirective(context = document.body) {
	const $context = $(context);

	$(function () {
		// https://tc39.github.io/ecma262/#sec-array.prototype.find
		if (!Array.prototype.find) {
			Object.defineProperty(Array.prototype, 'find', {
				value: function (predicate) {
					// 1. Let O be ? ToObject(this value).
					if (this == null) {
						throw TypeError('"this" is null or not defined');
					}

					var o = Object(this);

					// 2. Let len be ? ToLength(? Get(O, "length")).
					var len = o.length >>> 0;

					// 3. If IsCallable(predicate) is false, throw a TypeError exception.
					if (typeof predicate !== 'function') {
						throw TypeError('predicate must be a function');
					}

					// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
					var thisArg = arguments[1];

					// 5. Let k be 0.
					var k = 0;

					// 6. Repeat, while k < len
					while (k < len) {
						// a. Let Pk be ! ToString(k).
						// b. Let kValue be ? Get(O, Pk).
						// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
						// d. If testResult is true, return kValue.
						var kValue = o[k];
						if (predicate.call(thisArg, kValue, k, o)) {
							return kValue;
						}
						// e. Increase k by 1.
						k++;
					}

					// 7. Return undefined.
					return undefined;
				},
				configurable: true,
				writable: true
			});
		}

		setupProductPageButton();
		setupExtrasPageButton();
		setupOrderNowPageButton();
	});
}



// WEBPACK FOOTER //
// ./source/scripts/directives/action/productSubmit.js